export default __webpack_public_path__ + "static/media/logoFB.a13486ad.png";